/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BbsContentInfoRespVo } from './BbsContentInfoRespVo';
import {
    BbsContentInfoRespVoFromJSON,
    BbsContentInfoRespVoFromJSONTyped,
    BbsContentInfoRespVoToJSON,
    BbsContentInfoRespVoToJSONTyped,
} from './BbsContentInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseBbsContentInfoRespVo
 */
export interface ResponseBbsContentInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseBbsContentInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseBbsContentInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {BbsContentInfoRespVo}
     * @memberof ResponseBbsContentInfoRespVo
     */
    data?: BbsContentInfoRespVo;
}

/**
 * Check if a given object implements the ResponseBbsContentInfoRespVo interface.
 */
export function instanceOfResponseBbsContentInfoRespVo(value: object): value is ResponseBbsContentInfoRespVo {
    return true;
}

export function ResponseBbsContentInfoRespVoFromJSON(json: any): ResponseBbsContentInfoRespVo {
    return ResponseBbsContentInfoRespVoFromJSONTyped(json, false);
}

export function ResponseBbsContentInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBbsContentInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : BbsContentInfoRespVoFromJSON(json['data']),
    };
}

export function ResponseBbsContentInfoRespVoToJSON(json: any): ResponseBbsContentInfoRespVo {
    return ResponseBbsContentInfoRespVoToJSONTyped(json, false);
}

export function ResponseBbsContentInfoRespVoToJSONTyped(value?: ResponseBbsContentInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': BbsContentInfoRespVoToJSON(value['data']),
    };
}

